// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__HrArb","badges":"styles_badges__137AE"};